theme.initWhenVisible = function(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});

  observer.observe(options.element);
};

class OptionTable extends HTMLElement {
  constructor() {
    super();

    this.config = {
    };

    this.imageOptionRows = this.querySelectorAll(".ot--images .ot--option-row");
    this.dataOptionRows = this.querySelectorAll(".ot--data .ot--option-row");
    this.type = this.dataset.type || "vertical";
    if(this.type == "horizontal"){
      this.dataHeaderColums = this.querySelectorAll('.ot--option-col-header')
    }

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 600
    });
  }

  init() {
    const optionTable = this;

    if(this.type == "horizontal"){
      this.dataHeaderColums.forEach(dataHeaders => {
        let headerId = dataHeaders.id;
        let imageId = headerId.replace("dataHeaderCol", "imageRow");
        let dataColClass = headerId.replace("dataHeaderCol", "dataCol");
        dataHeaders.addEventListener("mouseenter", () => {
          this.imageOptionRows.forEach(image => {
            console.log(imageId ,image.id)
            image.style.opacity = (imageId == image.id) ? "1" : "0.3";
            image.style.zIndex = (imageId == image.id) ? "3" : "initial" ;
          });

          this.dataOptionRows.forEach(optionRow => {
            optionRow.querySelector(`.${dataColClass}`).classList.add('active');
          });
          
          dataHeaders.classList.add('active');
        });
        dataHeaders.addEventListener("mouseleave", () => {
          this.imageOptionRows.forEach((el) => {
            el.style.opacity = "1";
            el.style.zIndex = "initial";
          });
          this.dataOptionRows.forEach(optionRow => {
            optionRow.querySelector(`.${dataColClass}`).classList.remove('active');
          });
          dataHeaders.classList.remove('active');
        });
      });
    }

    this.imageOptionRows.forEach((imageOptionRow, index) => {
      
      let $this = imageOptionRow;
      imageOptionRow.addEventListener("mouseenter", () => {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "0.3";
          el.style.zIndex = "initial";
        });

        $this.style.opacity = "1";
        $this.style.zIndex = "3";

        if(this.type == "vertical") {
          this.imageOptionRows.forEach((ele) => ele.classList.remove("option-active"));
          $this.classList.add("option-active")
        }
        
        var imageRowId = $this.id;

        if(this.type == "horizontal"){
          let dataColClass = imageRowId.replace("imageRow", "dataCol");
          let dataHeaderColClass = imageRowId.replace("imageRow", "dataHeaderCol");
          this.querySelectorAll(`.${dataColClass}, #${dataHeaderColClass}`).forEach(el => el.classList.add('active'));
          optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank):not(.ot--option-col)`).forEach(el => {
            el.classList.remove('active');
          });
        }else{
          var dataRowId = imageRowId.replace("imageRow", "dataRow");
          var activeDataRow = optionTable.querySelector(`#${dataRowId}`);
          activeDataRow.classList.add("active");
          var activeDataRowValues = activeDataRow.querySelectorAll(`:scope div:not(.is-header)`);
          activeDataRowValues.forEach((activeDataRowValue, i) => {
            if (activeDataRowValue.querySelectorAll(`:scope svg.checkmark`).length > 0) {
              let ele = optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`)[i];
              if(ele) ele.classList.add('active');
            }
          });
          let activeElements = Array.from(activeDataRow.querySelectorAll('.js-checkbox-wrapp')).map(ele => (ele.querySelector('.svg_wrap') != null));
          this.querySelector('.js-headers').querySelectorAll('div:not(.blank)').forEach((ele,i) => ele.classList.toggle('active',activeElements[i]));
        }
      });
      
      if(this.type == "vertical" && index == 0) {
        imageOptionRow.dispatchEvent(new Event("mouseenter"));
      } 
      
      imageOptionRow.addEventListener("mouseleave", () => {
        optionTable.querySelectorAll(".ot--data .ot--option-row, .ot--data .ot--option-col").forEach((el) => {
          el.classList.remove("active");
        });
        optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
          el.style.opacity = "1";
        });
        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        });
      });
    });

    this.dataOptionRows.forEach((dataOptionRow) => {
      let $this = dataOptionRow;
      dataOptionRow.addEventListener("mouseenter", () => {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        $this.classList.add("active");
        
        if(this.type == "vertical"){
          optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
            el.style.opacity = "0.3";
          });
          optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
            el.style.zIndex = "initial";
          });
          var dataRowId = $this.id;
          var imageRowId = dataRowId.replace("dataRow", "imageRow");
          optionTable.querySelector(`#${imageRowId}`).style.opacity = "1";
          optionTable.querySelector(`#${imageRowId}`).style.zIndex = "3";
        }

      });
      dataOptionRow.addEventListener("mouseleave", () => {
        optionTable.querySelectorAll(".ot--data .ot--option-row").forEach((el) => {
          el.classList.remove("active");
        });
        if(this.type == "vertical"){
          optionTable.querySelectorAll(".ot--images .ot--option-row").forEach((el) => {
            el.style.opacity = "1";
          });
        }
        optionTable.querySelectorAll(`:scope .data-row.data-headers>div:not(.blank)`).forEach(el => {
          el.classList.remove('active');
        })
      });
    });
  }
}
customElements.define('option-table', OptionTable);